import BaseRepository from '@/api/BaseRepository';
import Customer from '@/models/Customer';

export default class CustomerRepository extends BaseRepository {

    private customerRoute = 'customer';

    public async getAllCustomers(): Promise<any> {
        return this.axiosClient.get(`${this.customerRoute}/`);
    }

    public async getCustomer(customerId: string): Promise<any> {
        return this.axiosClient.get(`${this.customerRoute}/${customerId}`);
    }

    public async createCustomer(customer: Customer): Promise<any> {
        const payload = {
            name: customer.name,
            street: customer.street,
            houseNo: customer.houseNo,
            additionalStreet: customer.additionalStreet,
            zipCode: customer.zipCode,
            city: customer.city,
            country: customer.country,
            contactPersons: customer.contactPersons
        };
        return this.axiosClient.post(`${this.customerRoute}`, payload);
    }

    public async updateCustomer(customer: Customer): Promise<any> {
        const payload = {
            name: customer.name,
            street: customer.street,
            houseNo: customer.houseNo,
            additionalStreet: customer.additionalStreet,
            zipCode: customer.zipCode,
            city: customer.city,
            country: customer.country,
            contactPersons: customer.contactPersons
        };

        return this.axiosClient.patch(`${this.customerRoute}/${customer.id}`, payload);
    }

    public async deleteCustomer(customerId: string): Promise<any> {
        return this.axiosClient.delete(`${this.customerRoute}/${customerId}`);
    }
}
